/**
 * Web Style Import
 *
 */

import './style'
